import { ParallaxBackground } from "@/ui/ParallaxBackground";
import { ParallaxHexagon } from "@/ui/ParallaxHexagon";
import { Tagline } from "@/ui/Tagline";
import cn from "classnames";
import { Col, Container, ListGroup, Row } from "react-bootstrap";
import { Parallax } from "react-scroll-parallax";

import bg_1 from "./bg_1.webp";
import bg_2 from "./bg_2.webp";
import bg_3 from "./bg_3.webp";
import classes from "./styles.module.scss";

export default function ({
  className = "py-6 py-md-7",
  tagline,
  title,
  description,
  image,
  image_hexagon = true,
  items,
  reverse = false,
  EditableText,
  EditableHtml,
  EditableImage,
  theme = "light",
}) {
  return (
    <div
      className={cn(className, classes.ContentListSideImage)}
      data-reverse={reverse}
      data-bs-theme={theme}
    >
      <ParallaxBackground anim="y2n:x0:z1" image={bg_1} className={classes.bg_1} />
      <ParallaxBackground anim="y1:x2:z0" image={bg_2} className={classes.bg_2} />
      <ParallaxBackground anim="y2:x0:z0" image={bg_3} floating={false} className={classes.bg_3} />
      <Container fluid="lg">
        <Row className={cn({ "flex-row-reverse": !reverse })}>
          <Col xs={12} md={6}>
            <div
              className={cn("px-4", {
                "ps-lg-0 pe-lg-6": reverse,
                "pe-lg-0 ps-lg-6": !reverse,
              })}
            >
              <div className="mb-3">
                <Tagline as={EditableText} path="tagline" tag="strong" className="d-block mb-3">
                  <span dangerouslySetInnerHTML={{ __html: tagline }} />
                </Tagline>
                <EditableText path="title" tag="h2">
                  <span dangerouslySetInnerHTML={{ __html: title }} />
                </EditableText>
                <EditableHtml path="description">
                  <div dangerouslySetInnerHTML={{ __html: description }} />
                </EditableHtml>
              </div>
              <ListGroup>
                {items.map(({ title, text }, idx) => (
                  <ListGroup.Item key={idx}>
                    {title && (
                      <EditableText
                        tag="h4"
                        path={`item_${idx}_title`}
                        dangerouslySetInnerHTML={{ __html: title }}
                      />
                    )}
                    <EditableText
                      path={`item_${idx}`}
                      className="mb-3"
                      dangerouslySetInnerHTML={{ __html: text }}
                    />
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </div>
          </Col>
          <Col xs={12} md={6} className="position-relative">
            {image_hexagon ? (
              <ParallaxHexagon translateY={[0, 20]} className={classes.img}>
                <EditableImage path="image" src={image} size="496x425" alt="" />
              </ParallaxHexagon>
            ) : (
              <Parallax translateY={[0, 20]} className={classes.img}>
                <EditableImage path="image" src={image} size="496x425" alt="" />
              </Parallax>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
}
